import React from 'react';
import { Box, Typography, Container, Paper } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const PaymentSuccess: React.FC = () => {
  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
        }}
      >
        <Paper
          elevation={3}
          sx={{
            padding: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <CheckCircleOutlineIcon 
            sx={{ 
              fontSize: 80, 
              color: 'success.main',
              mb: 2 
            }} 
          />
          
          <Typography variant="h4" component="h1" gutterBottom>
            Payment Successful!
          </Typography>
          
          <Typography variant="h6" color="text.secondary" gutterBottom sx={{ mt: 2 }}>
            Thank you for your payment
          </Typography>
          
          <Typography variant="body1" sx={{ mt: 2, mb: 1 }}>
            Your payment has been processed successfully and your contract has been accepted.
          </Typography>
          
          <Typography variant="body1" sx={{ mb: 2 }}>
            You will receive a confirmation email shortly with the details of your booking.
          </Typography>
          
          <Typography variant="body2" color="text.secondary" sx={{ mt: 3 }}>
            Your counsellor will be in touch soon to arrange your first session.
          </Typography>
          
          <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
            You may now close this window.
          </Typography>
        </Paper>
      </Box>
    </Container>
  );
};

export default PaymentSuccess;
